"use strict";

import jQuery from 'jquery';

gc.gis.widget.GCLayerSelectorSort = {
	NONE:       0,
	ASCENDING:  1,
	DESCENDING: -1
};

gc.gis.widget.GCLayerSelectorMode = {
	NONE:       1,
	ALL:        2,
	SELECTED:   4,
	VISIBLE:    8,
	SINGLE:     16
};

/**
 * @classdesc
 * Layer-Auswahlliste.
 *
 * @class
 * @extents gc.gis.widget.GCSelect
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.widget.GCLayerSelector = function(options)
{
	gc.gis.widget.GCSelect.call(this, options);

	/**
	 * @type {gc.gis.map.GCMapView}
	 * @private
	 */
	this._map = options.map;

	/**
	 * @type {number}
	 * @private
	 */
	this._sort = options.sort || gc.gis.widget.GCLayerSelectorSort.NONE;

	/**
	 * @type {number}
	 * @private
	 */
	this._mode = options.mode || (gc.gis.widget.GCLayerSelectorMode.NONE
		| gc.gis.widget.GCLayerSelectorMode.ALL
		| gc.gis.widget.GCLayerSelectorMode.SELECTED
		| gc.gis.widget.GCLayerSelectorMode.VISIBLE
		| gc.gis.widget.GCLayerSelectorMode.SINGLE);

	/**
	 * @type {Function}
	 * @private
	 */
	this._observeFilterFunc = this._createFilterFunc(options.observeLayerFilter, false);

	/**
	 * @type {Function}
	 * @private
	 */
	this._selectableFilterFunc = this._createFilterFunc(options.selectLayerFilter, true);

	/**
	 * @type {Array}
	 * @private
	 */
	this._layers = [];

	this._initEvents();
};
gc.gis.widget.GCLayerSelector.prototype = Object.create(gc.gis.widget.GCSelect.prototype);


/**
 * Liefert den ausgewählten Layer-Auswahl-Modus.
 */
gc.gis.widget.GCLayerSelector.prototype.getMode = function()
{
	return parseInt(this.getValue());
};

/**
 * Liefert den ausgewählten Layer, sofern eine Einzelauswahl getroffen wurde.
 * @return gc.gis.layer.GCLayer|undefined
 */
gc.gis.widget.GCLayerSelector.prototype.getSingleLayerSelection = function()
{
	var layer = [];
	if (this.getMode() === gc.gis.widget.GCLayerSelectorMode.SINGLE)
	{
		this._inputElement.find('option:selected').each(function() {
			layer.push(jQuery(this).data('__data'));
		});
	}

	return layer.length > 0 ? layer[0] : undefined;
};

/**
 * @inheritDoc
 */
gc.gis.widget.GCLayerSelector.prototype.updateOptions = function(options)
{
	var self = this,
		i, ii,
		singleLayerOptions = [],
		key,
		keysSorted = Object.keys(this._layers);

	// options können nicht von außen angegeben werden
	options = this._buildMultiLayerOptions();

	if (this._sort !== gc.gis.widget.GCLayerSelectorSort.NONE)
	{
		keysSorted = keysSorted.sort(function(a, b) {
			return self._layers[a].getName().localeCompare(self._layers[b].getName())
				* self._sort;
		});
	}

	//var currentLayer = self._module.getSelectedLayer();
	for (i = 0, ii = keysSorted.length; i < ii; i++)
	{
		key = keysSorted[i];
		singleLayerOptions.push({
			label: this._layers[key].getLabel(),
			value: gc.gis.widget.GCLayerSelectorMode.SINGLE,
			data: this._layers[key]
			//selected: currentLayer === this._layers[key]
		});
	}

	if (options.length > 1)
	{
		// Gruppierung nur, wenn Multiauswahl existiert
		options.push({
			label: 'Ebene (Einzelauswahl)',
			options: singleLayerOptions
		});
	}
	else
	{
		options = options.concat(singleLayerOptions);
	}

	gc.gis.widget.GCSelect.prototype.updateOptions.call(this, options);
};

/**
 * Initialisiert die Events des Steuerelements.
 * @private
 */
gc.gis.widget.GCLayerSelector.prototype._initEvents = function()
{
	if (this._mode & gc.gis.widget.GCLayerSelectorMode.SINGLE)
	{
		var self = this;
		this._map.on(gc.gis.map.GCMapEvent.LAYER_ADDED, this, function (evt) {
			var i, ii;
			if(evt.layers && evt.layers.length)
			{
				for(i = 0, ii = evt.layers.length; i < ii; i++)
				{
					if (self._observeFilterFunc(evt.layers[i]))
					{
						if (self._selectableFilterFunc(evt.layers[i]))
						{
							self._addLayer(evt.layers[i]);
						}

						evt.layers[i].on(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self, function(evt) {
							if (self._selectableFilterFunc(evt.layer))
							{
								self._addLayer(evt.layer);
							}
							else
							{
								self._removeLayer(evt.layer);
							}
						});
					}
				}
			}
		});

		this._map.on(gc.gis.map.GCMapEvent.LAYER_REMOVED, this, function (evt) {
			var i, ii;
			if(evt.layers && evt.layers.length)
			{
				for (i = 0, ii = evt.layers.length; i < ii; i++)
				{
					if (self._observeFilterFunc(evt.layers[i]))
					{
						evt.layers[i].un(gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, self);
						self._removeLayer(evt.layers[i]);
					}
				}
			}
		});
	}
};

/**
 * Fügt einen einzelnen Layer der Auswahlliste hinzu.
 * @param {gc.gis.layer.GCLayer} layer
 * @private
 */
gc.gis.widget.GCLayerSelector.prototype._addLayer = function(layer)
{
	this._layers[layer.getType() + '::' + layer.getName()] = layer;
	this.updateOptions();
};

/**
 * Entfernt einen einzelnen Layer von der Auswahlliste.
 * @param {gc.gis.layer.GCLayer} layer
 * @private
 */
gc.gis.widget.GCLayerSelector.prototype._removeLayer = function(layer)
{
	var key = layer.getType() + '::' + layer.getName();
	if (this._layers[key])
	{
		delete this._layers[key];
	}
	this.updateOptions();
};

/**
 * Erzeugt die Optionen für die gruppierte Layerauswahl.
 * @return {gc.gis.widget.GCSelectOption[]}
 * @private
 */
gc.gis.widget.GCLayerSelector.prototype._buildMultiLayerOptions = function()
{
	var options = [];

	if (this._mode & gc.gis.widget.GCLayerSelectorMode.NONE)
	{
		options.push({
			label: '<bitte auswählen>',
			value: gc.gis.widget.GCLayerSelectorMode.NONE
		});
	}

	if (this._mode & gc.gis.widget.GCLayerSelectorMode.VISIBLE)
	{
		options.push({
			label: 'angezeigte Ebenen',
			value: gc.gis.widget.GCLayerSelectorMode.VISIBLE
		});
	}

	if (this._mode & gc.gis.widget.GCLayerSelectorMode.SELECTED)
	{
		options.push({
			label: 'ausgewählte Ebenen',
			value: gc.gis.widget.GCLayerSelectorMode.SELECTED
		});
	}

	if (this._mode & gc.gis.widget.GCLayerSelectorMode.ALL)
	{
		options.push({
			label: 'alle Ebenen',
			value: gc.gis.widget.GCLayerSelectorMode.ALL
		});
	}

	return options;
};

/**
 * Erzeugt eine Filterfunktion für die Layer innerhalb der Auswahlliste.
 *
 * @param {Function|undefined} func Layer-Filterfunktion
 * @param {boolean} forSelect Flag, ob die Filterfunktion die Selektierbarkeit steuert
 * @return {Function}
 * @private
 */
gc.gis.widget.GCLayerSelector.prototype._createFilterFunc = function(func, forSelect)
{
	if (typeof func === 'function')
	{
		return func;
	}

	// standardmäßig alle Layer überwachen
	if (!forSelect)
	{
		return function (lyr) {
			return lyr instanceof gc.gis.layer.GCLayer;
		};
	}

	// standardmäßig nur sichtbare Layer zur Auswahl anbieten
	return function (lyr) {
		return lyr.isReallyVisible();
	};
};